<template>
        <!-- Intro -->
        <section id="intro">
            <a href="#" class="logo"><img src="../assets/images/logo.jpg" alt="" /></a>
            <header>
                <h2>Fernando Mata</h2>
                <h3>{{$t('intro.title')}}</h3>
                <p id="subtitle">{{$t('intro.subtitle')}}</p>
            </header>
            
            <section id="socialmedia">
                <SocialMedia />
            </section>
        </section>
</template>

<script>
    import SocialMedia from './SocialMedia.vue'

    export default {
        name: 'socialmedia',
        components: {
            SocialMedia
        }
    }
    
</script>

<style scoped>
    #subtitle {
        font-size: 70%;
    }
</style>

